import React, { useEffect, useCallback, useState, useRef } from 'react';
import { FormHandles } from '@unform/core';
import { FaTrashAlt } from 'react-icons/fa';

import { Alert, AlertIcon } from '@chakra-ui/react';

import api from '../../../services/api';
import InputSelect from '../../Inputs/Selects/InputSelect';
import Button from '../../Button';
import ModalHorarioRemove from '../ModalHorarioRemove';

import { Container, Content, Header, FormView } from './styles';

type HorarioData = {
  abertura: string;
  dia: number;
  fechamento: string;
  fim: number;
  id: number;
  inicio: number;
  tempo: number;
}
type DiaData = {
  d_semana: string;
  dia: number;
  tempo: number;
}
interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	dia: DiaData;
	horario: HorarioData;
	setHorarios: any;
	setSemana: any;
}

const horarios: any[] = [];

const ModalHorarios: React.FC<ModalParams> = ({
  id = 'modalHorarios',
  dia,
  horario,
  onClose = () => {},
  isVisible,
  setHorarios,
  setSemana,
}) => {
  const handleOutSideClick = useCallback(
		(e: any) => {
      if (e.target.id === id) {
        setVisible(false);

        setTimeout(() => {
          onClose();
        }, 300);
      }
    },
    [id, onClose],
  );

  const formRef = useRef<FormHandles>(null);

  const [visible, setVisible] = useState(isVisible);
  const [modalHorarioRemove, setModalHorarioRemove] = useState(false);

  const [messageVisible, setMessageVisible] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    for (let i = 0; i < 24; i++) {
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:00`,
        label: `${i < 10 ? `0${i}` : i}:00`,
      });
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:15`,
        label: `${i < 10 ? `0${i}` : i}:15`,
      });
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:30`,
        label: `${i < 10 ? `0${i}` : i}:30`,
      });
      horarios.push({
        id: `${i < 10 ? `0${i}` : i}:45`,
        label: `${i < 10 ? `0${i}` : i}:45`,
      });
    }
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      await api
        .post('portal/horario/add', {
          id: horario.id || 0,
          dia: dia.dia,
          abertura: data.abertura,
          fechamento: data.fechamento,
        })
        .then(response => {
          if (response.data.check.che === 'N') {
            setMessage(response.data.check.men);
            setMessageVisible(true);
            return;
          }

          setHorarios(response.data.horarios);
          setSemana(response.data.semana);

          setVisible(false);
          setTimeout(() => {
            onClose();
          }, 300);
        });
    },
    [dia, horario, setHorarios, setSemana, onClose],
  );

  const handleDelete = useCallback(async () => {
    await api.delete(`portal/horario/${horario.id}/remove`).then(response => {
      if (response.data.check.che === 'N') {
        setMessage(response.data.check.men);
        setMessageVisible(true);
        setModalHorarioRemove(false);
        return;
      }

      setHorarios(response.data.horarios);
      setSemana(response.data.semana);
      setModalHorarioRemove(false);

      setVisible(false);
      setTimeout(() => {
        onClose();
      }, 300);
    });
  }, [horario, setHorarios, setSemana, onClose]);

  return (
    <>
      {modalHorarioRemove && (
        <ModalHorarioRemove
          onClose={() => setModalHorarioRemove(false)}
          isVisible={modalHorarioRemove}
          dia={dia}
          horario={horario}
          handleDelete={handleDelete}
        />
      )}

      <Container id="modalHorarios" onClick={handleOutSideClick}>
        <Content className={`${visible ? 'active' : ''}`}>
          <Header>
            <h1>
              {horario.id
                ? `${dia.d_semana}${
                    dia.dia > 1 && dia.dia < 7 ? '-feira' : ''
                  } - ${horario.abertura}-${horario.fechamento}`
                : `Escolha um novo horário ${
                    dia.dia > 1 && dia.dia < 7 ? 'na' : 'no'
                  } ${dia.d_semana}${
                    dia.dia > 1 && dia.dia < 7 ? '-feira' : ''
                  }`}
            </h1>

            {horario.id && (
              <button
                title="Excluir"
                onClick={() => setModalHorarioRemove(!modalHorarioRemove)}
              >
                <FaTrashAlt />
              </button>
            )}
          </Header>

          <FormView ref={formRef} onSubmit={handleSubmit}>
            <div className="input-content">
              <div className="input">
                <span>Das</span>
                <InputSelect
                  name="abertura"
                  options={horarios}
                  placeholder="Abertura"
                  defaultValue={horario.abertura}
                />
              </div>

              <div className="input">
                <span>Até</span>
                <InputSelect
                  name="fechamento"
                  options={horarios}
                  placeholder="Fechamento"
                  defaultValue={horario.fechamento}
                />
              </div>
            </div>

            {messageVisible && (
              <Alert
                status="error"
                style={{
                  marginTop: '10px',
                  marginBottom: '10px',
                  borderRadius: '10px',
                }}
              >
                <AlertIcon />
                {message}
              </Alert>
            )}

            <div className="buttons">
              <Button
                type="button"
                onClick={() => {
                  setVisible(false);
                  setTimeout(() => {
                    onClose();
                  }, 300);
                }}
                style={{
                  backgroundColor: '#fff',
                  border: '2px solid #1a83ff',
                  color: '#1a83ff',
                  fontSize: '18px',
                }}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                style={{
                  paddingRight: '50px',
                  paddingLeft: '50px',
                  fontSize: '18px',
                }}
              >
                Adicionar
              </Button>
            </div>
          </FormView>
        </Content>
      </Container>
    </>
  );
};

export default ModalHorarios;
